<ion-list scrollY="true" lines="none" class="patient-call-question-list">
  <div *ngFor="let question of patientCallQuestions; let idx = index" formGroupName="{{ idx }}">
    <ng-container *ngIf="question.patientQuestionTypeLabel == 'textarea'">
      <div class="custom-question-container">
        <ion-label class="patient-call-question-label">
          {{ question.patientCallQuestion }}
        </ion-label>
      </div>
    </ng-container>
  </div>
</ion-list>
